import styled from 'styled-components';
import { parseTextShadowString } from '../../../../../functions/utils/parseTextShadowString';
import { Dropdown } from '../../../Dropdown';
import { ColorSwatch } from '../../../baseInputs/ColorSwatch';
import { NumberInput } from '../../../baseInputs/NumberInput';
import { ColorPickerModalContent } from '../../../baseInputs/colorInput/ColorPickerModalContent';

export const TextShadowInput = ({ value, onChange }: { value?: string; onChange: (newValue?: string) => void }) => {
  const shadow = parseTextShadowString(value);

  const createTextShadowString = ({
    offsetX = '0px',
    offsetY = '0px',
    blur = '10px',
    color = '#000',
  }: {
    offsetX?: string | null;
    offsetY?: string | null;
    blur?: string | null;
    color?: string | null;
  }) => {
    return `${offsetX} ${offsetY} ${blur} ${color}`;
  };

  return (
    <>
      <Label>Shadow</Label>
      <NumberInput
        value={shadow.blur || 0}
        onChange={(newValue) =>
          newValue !== undefined && onChange(createTextShadowString({ ...shadow, blur: String(newValue) }))
        }
        defaultUnit="px"
        precision={0}
        minValue={0}
        draggingSensitive={0.1}
        style={{ maxWidth: '50px' }}
        inputStyle={{ textAlign: 'center' }}
      />

      <div style={{ flex: 1 }} />

      <Dropdown
        trigger={
          <ColorSwatchContainer>
            <ColorSwatch value={shadow.color || undefined} />
          </ColorSwatchContainer>
        }
        closeOnClick={false}
        horizontalAlign="right"
      >
        <DropdownContentContainer>
          <ColorPickerModalContent
            value={shadow.color || undefined}
            onChange={(newValue) =>
              newValue !== undefined && onChange(createTextShadowString({ ...shadow, color: String(newValue) }))
            }
          />
        </DropdownContentContainer>
      </Dropdown>
    </>
  );
};

const Label = styled.label`
  padding-right: 5px;
  padding-left: 8px;

  color: var(--main-2);
  font-family: var(--font-2);
  font-size: 13px;
  white-space: nowrap;

  display: flex;
  align-items: center;

  i {
    width: 20px;
    font-size: 19px;
    translate: -2px 0;
  }
`;

const ColorSwatchContainer = styled.div``;

const DropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-left: 6px;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);
`;
